import { render, staticRenderFns } from "./Moves.vue?vue&type=template&id=522a488e&scoped=true&"
import script from "./Moves.vue?vue&type=script&lang=js&"
export * from "./Moves.vue?vue&type=script&lang=js&"
import style0 from "./Moves.vue?vue&type=style&index=0&id=522a488e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a488e",
  null
  
)

export default component.exports